import { useEffect } from "react";
import { X } from "lucide-react";

export type MetricDetailRow = {
  key: string;
  name: string;
  store: string;
  platform?: string;
  value: string;
};

export function MetricDetailModal({
  title,
  period,
  total,
  rows,
  onClose,
}: {
  title: string;
  period: string;
  total: string;
  rows: MetricDetailRow[];
  onClose: () => void;
}) {
  useEffect(() => {
    const closeOnEscape = (event: KeyboardEvent) => {
      if (event.key === "Escape") onClose();
    };
    window.addEventListener("keydown", closeOnEscape);
    return () => window.removeEventListener("keydown", closeOnEscape);
  }, [onClose]);

  return (
    <div className="modalLayer" onMouseDown={(event) => {
      if (event.target === event.currentTarget) onClose();
    }}>
      <section className="metricDetailModal" role="dialog" aria-modal="true" aria-labelledby="metric-detail-title">
        <header>
          <div>
            <h2 id="metric-detail-title">{title}明细</h2>
            <span>{period} · 共 {rows.length} 条客服记录</span>
          </div>
          <button className="iconButton bordered" aria-label="关闭指标明细" onClick={onClose}><X /></button>
        </header>
        <div className="metricDetailTotal"><span>当前汇总</span><strong>{total}</strong></div>
        <div className="metricDetailScroll">
          <table>
            <thead><tr>{rows.some((row) => row.platform) && <th>平台</th>}<th>客服</th><th>店铺</th><th>{title}</th></tr></thead>
            <tbody>{rows.map((row) => (
              <tr key={row.key}>
                {rows.some((item) => item.platform) && <td>{row.platform ?? "--"}</td>}
                <td><strong>{row.name}</strong></td>
                <td>{row.store}</td>
                <td><strong className="tmallMetric">{row.value}</strong></td>
              </tr>
            ))}</tbody>
          </table>
          {!rows.length && <div className="operationsEmpty">当前周期没有明细数据</div>}
        </div>
        <footer><button className="button primary" onClick={onClose}>关闭</button></footer>
      </section>
    </div>
  );
}
